import React, {
  FormEvent,
  Fragment,
  useContext,
  useEffect,
  useState,
} from "react";
import { Grid, Segment, Form, Button, Popup } from "semantic-ui-react";
import EmployeeBdodJobsList from "./EmployeeBdodJobsList";
import { observer } from "mobx-react-lite";
import BdodJobsStore from "../../../app/stores/bdodjobsStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { CSVLink } from "react-csv";

const EmployeeBdodJobsDashboard: React.FC = () => {
  const bdodjobsStore = useContext(BdodJobsStore);
  const { submitting, searchBdodJobs, bdodjobsByDate, bdodjobRegistry } =
    bdodjobsStore;

  useEffect(() => {
    bdodjobRegistry.clear();
  }, []);

  const [search, setSearch] = useState({
    tech: "portal",
    status: "",
    jobStartDate: "",
    jobEndDate: "",
    workNo: "",
  });

  if (bdodjobsStore.loadingInitial)
    return <LoadingComponent content="Loading BDOD Jobs" />;

  const handleSubmit = () => {
    searchBdodJobs(search);
  };

  const statusOptions = [
    { key: "Complete", text: "Complete", value: "Complete" },
    { key: "In Progress", text: "In Progress", value: "In Progress" },
    { key: "New Job", text: "New Job", value: "New Job" },
  ];

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setSearch({ ...search, [name]: value });
  };

  return (
    <Segment>
      <Form onSubmit={handleSubmit}>
        <Grid columns={2}>
          <Grid.Column>
            <Form.Select
              label="Status"
              onChange={(e, { name, value }) =>
                setSearch({ ...search, [name]: value })
              }
              options={statusOptions}
              search
              name="status"
              placeholder="Status"
              value={search.status}
              clearable
            />
          </Grid.Column>
        </Grid>
        <Grid columns={2}>
          <Grid.Column>
            <Form.Input
              label="Job Start Date"
              onChange={handleInputChange}
              name="jobStartDate"
              type="date"
              placeholder="Date"
              clearable
              value={search.jobStartDate}
            />
          </Grid.Column>
          <Grid.Column>
            <Form.Input
              label="Job End Date"
              onChange={handleInputChange}
              name="jobEndDate"
              type="date"
              placeholder="Date"
              clearable
              value={search.jobEndDate}
            />
          </Grid.Column>
        </Grid>
        <Grid columns={2}>
          <Grid.Column>
            <Form.Input
              label="Work Order No."
              onChange={handleInputChange}
              name="workNo"
              placeholder="Work Order No."
              value={search.workNo}
            />
          </Grid.Column>
          <Grid.Column>
            <Button
              loading={submitting}
              floated="left"
              positive
              type="submit"
              content="Search"
              style={{ marginTop: "1.5rem" }}
            />
          </Grid.Column>
        </Grid>
      </Form>
      <CSVLink data={bdodjobsByDate} filename={"bdodjoblist.csv"}>
        <Popup
          content="Download as CSV"
          trigger={
            <Button
              icon="download"
              floated="right"
              style={{ marginTop: "-3rem" }}
            />
          }
        />
      </CSVLink>
      <EmployeeBdodJobsList />
    </Segment>
  );
};

export default observer(EmployeeBdodJobsDashboard);
